import { Breadcrumb } from 'components/breadcrumb'
import { useHistory, useRouteMatch } from 'react-router'

import { TransmissaoDetailRootView } from './TransmissaoDetailRootView'
import { TransmissaoTabRootView } from './TransmissaoTabRootView'

export function TransmissaoRootView() {
  const match = useRouteMatch()
  const history = useHistory()

  const toRender = history.location.pathname.startsWith(`${match.url}/detail/`) ? (
    <TransmissaoDetailRootView />
  ) : (
    <TransmissaoTabRootView />
  )

  return (
    <>
      <Breadcrumb title='Transmissão de dados' />
      {toRender}
    </>
  )
}
